/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { MeetingLinkType } from '../enums/meeting-link-type';
export class CalendarEventConversationEntity extends Entity {
  cancelled: boolean = false;
  endTime: string | null = null;
  id: string = '';
  meetingLinkType: MeetingLinkType | null = null;
  startTime: string | null = null;
  unavailableAlertSentAt: string | null = null;
  candidateAccepted?: boolean | null = null;
  meetingLink?: string | null = null;
  nonCandidateAccepted?: boolean | null = null;
  static override key = 'CalendarEventConversation';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CalendarEventConversation' in input
    ) {
      const { CalendarEventConversation: wrapped, ...rest } = input as {
        CalendarEventConversation: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}